const BaseTestHost = {
  "me-live-websit": "h5-hiya-test.youyisia.com",
  "hiya-web": "hiya-web-test.youyisia.com",
  activity: "activity-hiya-web-test.youyisia.com",
  version: "version-hiya-web-test.youyisia.com",
  //
  static: "static-hiya-test.youyisia.com",
  "other-static": "static-hiya-web.mehiya.com",
  //
  api: "api-hiya-test.youyisia.com",
  //
  img01: "me-media-gateway.test03.youyisia.com",
  video01: "video01.srv.test.ixiaochuan.cn"
};
const TestHost = [BaseTestHost];
export {
  BaseTestHost,
  TestHost
};
